// Filter Categories
function onCategoryChange($radioInput) {
  var $ = jQuery.noConflict();
  var showID = $radioInput.attr('id');


  // Helper to reset all tabs in the wrap
  function resetTabs() {
    $('.category-selector-wrap .category-selection-button')
      .removeClass('selected')
    // .attr('aria-selected', 'false')
    // .attr('tabindex', '-1');
  }

  // // Helper to activate a specific tab
  function activateTab(id) {
    $('.category-selector-wrap .category-selection-button#' + id)
      .addClass('selected')
    // .attr('aria-selected', 'true')
    // .attr('tabindex', '0');
  }

  if (
    $($radioInput).attr('id') === 'all'
    || (window.innerWidth < 1440 && $('#category-dropdown option:selected').val() === 'all'
      && showID === 'category-dropdown'
      && !localStorage.getItem('readOnlyCategoryMenuItemCarryOver'))
  ) {
    // console.log('#1');
    $("[data-menu-category-template]").addClass("option-hide");

    // ACCESSIBILITY UPDATE: Reset all and set "all" to selected
    resetTabs();
    activateTab('all');

    $('.category-selector').removeClass("option-hide");
    history.pushState(null, '', '/order/#menu');

  } else {
    // console.log('#2');

    $('[data-menu-category-template]').addClass("option-hide");
    showIDFilter = showID.replace('panel-', '');
    // console.log('showIDFilter', showIDFilter);
    if (showID === 'category-dropdown' || showID === 'all') {

      showID = $('#category-dropdown option:selected').val();
      // console.log('#4.1', showID);

      // if ((!showID && !showID.length)) {
      showIDFilter = showID.replace('panel-', '');
      $('[data-menu-category-template][data-category-id="' + showIDFilter + '"]').removeClass("option-hide");
      if (showID === 'all') {
        // console.log('#3.1', showIDFilter, $('.category-selector'));

        $('#category-dropdown option[value="' + showIDFilter + '"]').prop('selected', true);
        $("[data-menu-category-template]").addClass("option-hide");
        resetTabs();
        activateTab('all');
        $('.category-selector').removeClass("option-hide");
        history.pushState(null, '', '/order/#menu');
      } else {
        // console.log('#3', showIDFilter);

        $('#category-dropdown option[value="panel-' + showIDFilter + '"]').prop('selected', true);
        $('.category-selector').addClass("option-hide");

      }


      change_view('menu-category-' + showIDFilter, true);

      // }
    } else {
      // console.log('#4', showIDFilter);

      // ACCESSIBILITY UPDATE: Reset all and set the specific ID to selected
      resetTabs();
      activateTab(showIDFilter);

      $('#category-dropdown option[value="panel-' + showIDFilter + '"]').prop('selected', true);
      change_view('menu-category-' + showIDFilter, true);
      $('.category-selector').addClass("option-hide");

    }

    $('[data-menu-category-template][data-category-id="' + showID + '"]').removeClass("option-hide");

    $backBtn.find("[data-button-label]").html("Back");
    $defaultBackAction = false;
    $backBtn.click(function () {
      $(
        '[data-category-selector-template]:not(.hide) input[type="radio"]'
      ).prop("checked", false);
      $(
        "[data-category-selector-template]:not(.hide), .wf-ordering-menu .heading"
      ).removeClass("option-hide");
      $("[data-menu-category-template]:not(.hide)").removeClass(
        "option-hide"
      );
      $(".category-selector").removeClass("option-hide");
      $("[data-back-button] [data-button-label]").html("Back");
      $defaultBackAction = true;
    });
  }

  const headerOffset = 100; // adjust as needed
  $('html, body').animate({
    scrollTop: $('.alignfull.menu-category:not(.hide)').offset().top - headerOffset
  }, 300);
  // console.log($('.alignfull.menu-category:not(.hide)'));
}
// View: Menu
function view_menu(openCart = false) {
  var $ = jQuery;

  $("html").removeClass("is-reveal-open");

  // $("#shopping-cart-view").foundation("close");
  ecw_show_loading();

  // Reroute if no location or cart is selected
  if (
    localStorage.getItem("ecw_customer_store_location_id") === null ||
    localStorage.getItem("ecw_customer_basket_id") === null
  ) {
    change_view("start-order");
    ecw_hide_loading();
    return;
  }

  // Show location menu
  $contentContainer
    .load(templateRoot + "wf-ordering-menu.html", function () {

      $(document).foundation();
      activateInviteOthers($("#invite-others-to-group-order-form"));
      //get group order 
      const customerLSGroupOrderGuid = localStorage.getItem("ecw_customer_grouporderGuid");
      const customerLSuserType = localStorage.getItem("ecw_customer_group_order_user_type");
      if (customerLSGroupOrderGuid && customerLSGroupOrderGuid.trim() !== "" && customerLSuserType && customerLSuserType.trim() !== "") {
        // console.log('asdgasdg')
        getGroupOrder().then(function (result) {
          // console.log('result', result);
          if (result.message) {
            $(document).foundation();
            $('#group-order-error').foundation('open');
            $('#group-order-error [data-error-message]').text(result.message);

            localStorage.removeItem('ecw_customer_grouporderGuid');
            localStorage.removeItem('ecw_customer_basket_id');
            localStorage.removeItem('ecw_customer_group_order_name');
            localStorage.removeItem('ecw_customer_group_order_user_type');
            localStorage.removeItem('ecw_customer_host_group_order_name');


          } else if (result.status === "locked" && localStorage.getItem('ecw_customer_group_order_user_type') === "host") {
            $(document).foundation();
            $('#group-order-unlock').foundation('open');

          } else if (result.status === "locked") {
            $(document).foundation();
            $('#group-order-error').foundation('open');

            $('#group-order-error [data-error-message]').text(`Looks like the host closed this group order. Because of this, you can no longer add items to the order. You can wait for the host to place the order or place your own order.`);
            // localStorage.removeItem('ecw_customer_grouporderGuid');
            // localStorage.removeItem('ecw_customer_basket_id');
            localStorage.removeItem('ecw_customer_group_order_name');
            localStorage.removeItem('ecw_customer_group_order_user_type');
            localStorage.removeItem('ecw_customer_group_order_name');


          } else if (result.status === "cancelled") {
            $(document).foundation();
            $('#group-order-error').foundation('open');

            $('#group-order-error [data-error-message]').text(`Looks like the host cancelled this group order. Because of this, you can no longer add items to the order. You can still place your own order!`);
            // localStorage.removeItem('ecw_customer_grouporderGuid');
            // localStorage.removeItem('ecw_customer_basket_id');
            localStorage.removeItem('ecw_customer_grouporderGuid');
            localStorage.removeItem('ecw_customer_basket_id');
            localStorage.removeItem('ecw_customer_group_order_name');
            localStorage.removeItem('ecw_customer_group_order_user_type');
            localStorage.removeItem('ecw_customer_host_group_order_name');

          } else if (result.status === "confirmed") {
            $(document).foundation();
            $('#group-order-error').foundation('open');

            $('#group-order-error [data-error-message]').text(`Looks like the host already placed this group order. Because the order is already placed, you can no longer add items to the order. You can still place your own order!`);

            localStorage.removeItem('ecw_customer_group_order_name');
            localStorage.removeItem('ecw_customer_group_order_user_type');
            localStorage.removeItem('ecw_customer_group_order_name');

          }

          const hostFullName = result.hostfullname;
          const formattedName = (hostFullName + "'S ").toUpperCase();
          $('[data-group-order-name]').text(formattedName);
          localStorage.setItem('ecw_customer_host_group_order_name', hostFullName);

          if (customerLSuserType === 'notHost') {
            $('[data-group-order-hide-if-not-participant]').removeClass('hide');
            $('[data-group-order-hide-if-not-host]').addClass('hide');
            $('[data-not-host-placed-group-order]').removeClass('hide');
            $('[data-host-placed-group-order]').addClass('hide');
            $('[data-group-order]').addClass('hide');
            $('[data-edit-order-details]').addClass('hide');
            $('[data-customer-group-order-name]').text(' ' + localStorage.getItem("ecw_customer_group_order_name"));
          } else {
            $('[data-group-order-hide-if-not-host]').addClass('hide');
            $('[data-group-order-hide-if-not-participant]').addClass('hide');

            $('[data-host-placed-group-order]').removeClass('hide');
            $('[data-not-host-placed-group-order]').addClass('hide');
            $('[data-group-order]').addClass('hide');
            $('[data-edit-order-details]').remove('hide');

            let shareLink = window.location.origin + '/order/#group-order/join?groupOrderID=' + localStorage.getItem("ecw_customer_grouporderGuid") + '&storeID=' + localStorage.getItem("ecw_customer_store_location_id");
            // console.log('shareLink', shareLink);              

            //copy link 
            $('[data-copy-group-order-link]').on('click', function (e) {
              // console.log('i click');
              e.preventDefault();

              if (navigator.clipboard) {
                navigator.clipboard.writeText(shareLink).then(function () {
                  // Success notification
                  // alert('Link copied to clipboard!');
                }, function (err) {
                  // Error notification
                  console.error('Could not copy text: ', err);
                  alert('Failed to copy link. Please try again.');
                });
              } else {
                // Fallback for older browsers
                // console.log('Clipboard API not supported.');
                alert('Your browser does not support the Clipboard API. Please copy the link manually.');
              }
            });
            //share link 
            $('[data-share-group-order-link]').on('click', function (e) {
              console.log('i click')
              e.preventDefault();
              const emailBody = "Join our group order by going to: " + shareLink;

              // Use mailto: to open the user's default email client
              window.location.href = 'mailto:?subject=Join Our Group Order!&body=' + encodeURIComponent(emailBody);
            });

          }
          ecw_hide_loading();

        });
      } else {
        $('[data-host-placed-group-order]').addClass('hide');
        $('[data-host-placed-group-order]').addClass('hide');
        $('[data-host-placed-group-order]').addClass('hide');
        $('[data-group-order]').removeClass('hide');
        $('[data-edit-order-details]').removeClass('hide');
        $('[data-group-order-hide-if-not-host]').removeClass('hide');
        $('[data-group-order-hide-if-not-participant]').addClass('hide');
      }
      //END get group order 
      $(window).on('scroll resize', function () {
        const $stickies = $('.pricing-sticky'); // use a class instead of ID for multiple

        $stickies.removeClass('no-sticky');
        // console.log($stickies, 'sticky');

        // const $header = $('header');
        // const $leftCol = $('.left-col');
        const $footer = $('footer');

        // Loop through each sticky
        $stickies.each(function () {
          const $sticky = $(this);

          // Pricing sticky logic
          const viewportBottom = $(window).scrollTop() + $(window).height();
          const footerTop = $footer.offset().top;

          if (viewportBottom >= footerTop) {
            // console.log($sticky, 'no-sticky')
            $sticky.addClass('no-sticky');
          } else {
            $sticky.removeClass('no-sticky');
            // console.log($sticky, 'sticky');
          }
        });

        // Left column sticky logic (not per-sticky)
        // if ($header.length && $leftCol.length) {
        //   const headerHeight = $header.outerHeight();
        //   const scrollTop = $(window).scrollTop();

        //   if (scrollTop > headerHeight) {
        //     $leftCol.addClass('sticky');
        //   } else {
        //     $leftCol.removeClass('sticky');
        //   }
        // }
      });


      const $categorySelectorWrap = $('.category-selector-wrap');
      const scrollSpeed = 5; // Adjust the scroll speed as needed

      function checkScrollPosition() {
        const atEnd = $categorySelectorWrap.scrollLeft() + $categorySelectorWrap.innerWidth() >= $categorySelectorWrap[0].scrollWidth;
        const atStart = $categorySelectorWrap.scrollLeft() <= 0;

        $('#see-more-categories-left').toggleClass('disabled', atStart).prop('disabled', atStart);
        $('#see-more-categories-right').toggleClass('disabled', atEnd).prop('disabled', atEnd);
      }

      let scrollInterval;

      $('#see-more-categories-left, #see-more-categories-right').on('mouseenter', function () {
        const direction = $(this).attr('id').includes('right') ? 1 : -1;
        scrollInterval = setInterval(function () {
          $categorySelectorWrap.scrollLeft($categorySelectorWrap.scrollLeft() + scrollSpeed * direction);
          checkScrollPosition();
        }, 10);
      }).on('mouseleave', function () {
        clearInterval(scrollInterval);
      });

      // Add scroll event listener to the container
      $categorySelectorWrap.on('scroll', function () {
        checkScrollPosition();
      });

      // Initial check and check on resize 
      $('#see-more-categories-left').addClass('disabled').prop('disabled', true);
      $(window).on('resize', checkScrollPosition);

      let menuPageCallOutClone = $('.menu-page-callout.hide').clone();
      menuPageCallOutClone.insertAfter('.menu-callout-positioner');
      menuPageCallOutClone.removeClass('hide');

      var editBasketItem = 0,
        editBasketProduct = 0;
      if (window.location.hash.split("_").length > 1) {
        editBasketItem = Number(window.location.hash.split("_")[1]);
        editBasketProduct = Number(window.location.hash.split("_")[2]);
        // console.log("Edit Item: " + editBasketItem + ", " + editBasketProduct);
      }

      $("#product-item-qty").change(function () {
        calculateProductTotal();
        console.log('calculate total');
      });

      $.when(
        olo_get_restaurant(
          localStorage.getItem("ecw_customer_store_location_id")
        )
      ).done(function (restaurant_data_json) {
        var restaurant_data = JSON.parse(restaurant_data_json);
        // console.log('restaurant_data', restaurant_data); 
        if (restaurant_data.availabilitymessage) {
          $('.menu-category [data-availabilitymessage]').removeClass('hide').text(restaurant_data.availabilitymessage);
        } else {
          $('.menu-category [data-availabilitymessage]').addClass('hide');
        }

        $("[data-menu-selected-store]").text(restaurant_data.name);

        restaurant_data.labels.forEach(function (label) {
          if (
            label.key ==
            "handoffmode_" +
            localStorage.getItem("ecw_customer_deliverymode")
          ) {
            $("[data-menu-handoff-mode]").text(label.value);
          }
        });

        var customer_schedule = localStorage.getItem(
          "ecw_customer_schedule"
        );
        if (customer_schedule !== "asap") {
          var scheduledTime = localStorage.getItem(
            "ecw_customer_scheduled_time"
          );

          // console.log(scheduledTime);

          if (scheduledTime.substring(0, 2) > 12) {
            scheduledTime =
              scheduledTime.substring(0, 2) -
              12 +
              scheduledTime.substring(2) +
              " PM";
          } else {
            scheduledTime = scheduledTime + " AM";
          }

          customer_schedule =
            "at " +
            scheduledTime +
            " on " +
            localStorage.getItem("ecw_customer_scheduled_day");
        } else {
          customer_schedule = customer_schedule.toUpperCase();
        }
        $("[data-menu-handoff-time]").text(customer_schedule);

        // show formatted store hours
        var hoursCalendar;
        var calendarMatched = false;

        // if there is a specific calendar of hours for this delivery type (e.g. dispatch), use it
        restaurant_data.calendar.every(function (calendar) {
          if (calendar.type == localStorage.getItem('ecw_customer_deliverymode')) {
            hoursCalendar = calendar;
            calendarMatched = true;
          }

          return !calendarMatched;
        });

        // otherwise use the regular business hours
        if (calendarMatched == false) {
          restaurant_data.calendar.every(function (calendar) {
            if (calendar.type == 'business') {
              hoursCalendar = calendar;
              calendarMatched = true;
            }

            return !calendarMatched;
          });
        }

        // format the stupid nonstandard olo dates
        var startDateRaw = hoursCalendar.ranges[0].start;
        var endDateRaw = hoursCalendar.ranges[0].end;

        var jsStartDate = new Date(startDateRaw.substring(0, 4), startDateRaw.substring(4, 6), startDateRaw.substring(6, 8), startDateRaw.substring(9, 11), startDateRaw.substring(12, 14), 0, 0);
        var jsEndDate = new Date(endDateRaw.substring(0, 4), endDateRaw.substring(4, 6), endDateRaw.substring(6, 8), endDateRaw.substring(9, 11), endDateRaw.substring(12, 14), 0, 0);

        var startTimeFormatted = jsStartDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        var endTimeFormatted = jsEndDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

        $('.store-hours').text('Hours ' + startTimeFormatted + ' - ' + endTimeFormatted);

        $('[data-store-info]').removeClass('hide');
      });
      //Delete group order 
      $("#cancelGroupOrder").click(function () {
        // console.log('i click');
        cancelGroupOrder();
      });
      $("#open-order").click(function () {
        // console.log('asdgasdg');
        lockGroupOrder(lockGroupOrder = false);

        $('#group-order-unlock').foundation('close');

      });
      $('#start-group-order').click(function () {
        // console.log('i click');
        shouldClearBasket = false
        signout(shouldClearBasket);
        change_view('group-order-login');

      });
      // Start New Order (reset cart)
      $("#start-new-order-button").click(function () {
        ecw_show_loading();

        $.when(
          olo_create_basket(
            localStorage.getItem("ecw_customer_store_location_id"),
            false,
            true
          )
        ).done(function (ocb) {
          console.log('update basket test #3');

          updateBasketDisplay();
          ecw_hide_loading();
        });
      });

      $("#edit-location").click(function () {
        change_view("start-order");
      });

      // Remove reveal modals
      $(
        "#account-select-order-type, #home-select-order-type",
        "#menu-select-order-type",
        "#location-detail-order-type"
      ).each(function () {
        if (typeof $(this).attr("aria-hidden") !== "undefined") {
          $(this).parent().remove();
        }
      });

      // Recreate reveal modals
      var $select_order_type_reveal = new Foundation.Reveal(
        $("#menu-select-order-type"),
        {}
      );

      $('input[name="menu-order-type"]').change(function () {
        clearLocationList();

        if ($('input[name="menu-order-type"]').val() !== "dispatch") {
          $("[data-search-deliver]").addClass("hide");
          $("#menu-order-location-search").addClass("hide");
          $(".fa-location-dot").addClass("hide");
          $("#menu-order-location-search-building").val("");
        } else {
          $("[data-search-deliver]").removeClass("hide");
          $("#menu-order-location-search").removeClass("hide");
          $(".fa-location-dot").removeClass("hide");
        }

        if ($("#menu-order-location-search").val()) {
          $("#menu-order-location-search-form").submit();
        } else {
          populate_user_restaurants("menu");
        }
      });

      // Hide/show schedule elements
      $('input[name="menu-order-schedule"]').change(function () {
        if ($('input[name="menu-order-schedule"]:checked').val() == "advance") {
          $("#menu-schedule-time").removeClass("hide");
        } else {
          $("#menu-schedule-time").addClass("hide");
        }
      });

      var todaysDate = new Date();
      var tomorrowsDate = new Date().addDays(1);
      var scheduleDates = getDates(todaysDate, new Date().addDays(45));
      var daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      for (var i = 0; i < scheduleDates.length; i++) {
        var dayValue =
          scheduleDates[i].getFullYear() +
          "-" +
          zeroPad(scheduleDates[i].getMonth() + 1, 2) +
          "-" +
          zeroPad(scheduleDates[i].getDate(), 2);
        var dayLabel =
          daysOfWeek[scheduleDates[i].getDay()] +
          " " +
          (scheduleDates[i].getMonth() + 1) +
          "/" +
          scheduleDates[i].getDate();

        if (scheduleDates[i].getTime() === todaysDate.getTime()) {
          dayLabel = "Today";
        }
        if (scheduleDates[i].getTime() === tomorrowsDate.getTime()) {
          dayLabel = "Tomorrow";
        }

        $("[data-menu-order-time-wanted-day]").append(
          '<option value="' + dayValue + '">' + dayLabel + "</option>"
        );
      }

      var timeSelection = createQuarterHourIntervals();

      for (var ii = 0; ii < timeSelection.length; ii++) {
        $("[data-menu-order-time-wanted-time]").append(
          '<option value="' +
          convert12to24Hour(timeSelection[ii]) +
          '">' +
          timeSelection[ii] +
          "</option>"
        );
      }

      $("select#menu-time-wanted-day").change(function () {
        if (
          $(
            'select#menu-time-wanted-day option[value="' + $(this).val() + '"]'
          ).text() == "Today"
        ) {
          var currentTime = convert12to24Hour(formatAMPM(roundToNearest15()));
          // console.log(currentTime);
          $("select#menu-time-wanted-time-slot option").each(function () {
            if ($(this).val() < currentTime) {
              $(this).addClass("hide");
            }
            $("select#menu-time-wanted-time-slot").val(currentTime);
          });
        } else {
          $("select#menu-time-wanted-time-slot option").each(function () {
            $(this).removeClass("hide");
          });
        }
      });

      $("select#menu-time-wanted-day").trigger("change");

      // Autocomplete for location search
      if ($("#menu-order-location-search").length) {
        const inputD = $("#menu-order-location-search")[0];
        const options = {
          // componentRestrictions: { country: "us" },
          fields: ["address_components", "geometry"],
          strictBounds: false,
          // types: ['(regions)'],
        };

        const autocompleteD = new google.maps.places.Autocomplete(
          inputD,
          options
        );
        autocompleteD.addListener("place_changed", function () {
          const place = autocompleteD.getPlace();
          if (place.geometry) {
            // ttmap.systemZoomChange = true;
            // getLocations(place.geometry.location.lat(), place.geometry.location.lng(), '', true);
            olo_get_nearby_locations(
              place.geometry.location.lat(),
              place.geometry.location.lng(),
              "",
              "menu"
            );
            // console.log(place);

            var components = {};
            $.each(place.address_components, function (k, v1) {
              $.each(v1.types, function (k2, v2) {
                components[v2] = v1.long_name;
              });
            });

            if (components.street_number && components.route) {
              $("#menu-order-location-search-streetaddress").val(
                components.street_number + " " + components.route
              );
            }

            if ('locality' in components) {
              $('#menu-order-location-search-city').val(components.locality);
            } else if ('administrative_area_level_2' in components) {
              $('#menu-order-location-search-city').val(components.administrative_area_level_2);
            }

            $("#menu-order-location-search-zipcode").val(
              components.postal_code
            );

            // console.log($('#order-location-search-streetaddress').val());
            // console.log($('#order-location-search-city').val());
            // console.log($('#order-location-search-zipcode').val());
          }
        });

        $("#menu-order-location-search-form").submit(function (e) {
          e.preventDefault();

          // console.log("search locations");

          $("#menu-order-location-search").blur();

          var address = $("#menu-order-location-search").val();
          var geocoder = new google.maps.Geocoder();

          if (address.length) {
            geocoder.geocode(
              {
                address: address,
              },
              function (results, status) {
                // console.log("GEOCODER STATUS ", status, results);
                if (status == google.maps.GeocoderStatus.OK) {
                  // console.log(results);

                  var components = {};
                  $.each(results[0].address_components, function (k, v1) {
                    $.each(v1.types, function (k2, v2) {
                      components[v2] = v1.long_name;
                    });
                  });

                  // console.log('address components', components);

                  if (components.street_number && components.route) {
                    $("#menu-order-location-search-streetaddress").val(
                      components.street_number + " " + components.route
                    );
                  }

                  if ('locality' in components) {
                    $('#menu-order-location-search-city').val(components.locality);
                  } else if ('administrative_area_level_2' in components) {
                    $('#menu-order-location-search-city').val(components.administrative_area_level_2);
                  }

                  $("#menu-order-location-search-zipcode").val(
                    components.postal_code
                  );

                  olo_get_nearby_locations(
                    results[0].geometry.location.lat(),
                    results[0].geometry.location.lng(),
                    "",
                    "menu"
                  );
                } else {
                  $("#menu-order-location-search").val("");
                  ecw_hide_loading();
                }
              }
            );
          } else {
            ecw_hide_loading();
          }
        });
        // initMap();
      }

      $(".edit-handoff").click(function () {
        ecw_show_loading();

        // console.log('i click');
        window.scrollTo(0, 0);
        // Close all open reveals before opening a new one
        // $('.reveal').foundation('close');
        $("#menu-select-order-type").foundation("open");

        loadInStoreEditInfo();
        // console.log('i finsh');

      });

      // Get Menu and Set Up Selections
      $.ajax({
        type: "POST",
        url: ajax_url,
        data: {
          action: "get_olo_get_menu",
          restaurant_id: localStorage.getItem(
            "ecw_customer_store_location_id"
          ),
          referer: window.location.href
        },
        success: function (response) {
          // console.log('get_olo_get_menu', JSON.parse(response));

          // $('.menu-page-callout').insertAfter('.start-group-order');
          // $('.menu-page-callout').removeClass('hide');

          var menu = JSON.parse(response);
          //menu category 
          let readOnlyCategoryMenuItemCarryOver = localStorage.getItem('readOnlyCategoryMenuItemCarryOver');
          if (readOnlyCategoryMenuItemCarryOver) {
            readOnlyCategoryMenuItemCarryOver = readOnlyCategoryMenuItemCarryOver.toLowerCase();
          }
          let readOnlyCategoryMenuItemCarryOverImg = localStorage.getItem('readOnlyCategoryMenuItemCarryOverImg');

          //menu item
          let readOnlyMenuItemCarryOver = localStorage.getItem('readOnlyMenuItemCarryOver');
          // console.log('readOnlyMenuItemCarryOver', readOnlyMenuItemCarryOver);
          if (readOnlyMenuItemCarryOver) {
            readOnlyMenuItemCarryOver = readOnlyMenuItemCarryOver.toLowerCase();
          }
          let readOnlyMenuItemCarryOverImg = localStorage.getItem('readOnlyMenuItemCarryOverImg');

          let matchFound = false;
          let matchProductID = null;
          // populate fave/recent order callout
          var callout_products = [];
          var recents_complete = false;
          var faves_complete = false;

          if (isUserLoggedIn(true)) {
            $("[data-menu-fave-callout]").removeClass("hide");
          }

          // create menu categories and single use categories
          function createMenuCategories(index, menu_cat) {
            //read only menu filter 
            const normalize = (str) => str.replace(/–/g, '-').replace(/—/g, '-').replace(/'/g, '');
            const sanitize = (str) => normalize(str.replace(/\s+/g, ' ').trim()).replace(/ /g, '-');

            if (readOnlyCategoryMenuItemCarryOver &&
              sanitize(menu_cat.name.toLowerCase()) === sanitize(readOnlyCategoryMenuItemCarryOver.toLowerCase())) {
              // console.log('Matching product:', menu_cat.name, menu_cat.id);
              matchFound = true;
              matchProductID = menu_cat.id;
            }
            // console.log(sanitize(menu_cat.name.toLowerCase()), matchFound, sanitize(readOnlyCategoryMenuItemCarryOver.toLowerCase()));

            //end read only menu filter
            var $cat_template = $(
              "[data-category-selector-template].hide"
            ).clone();

            var $cat_template = $(
              "[data-category-selector-template].hide"
            ).clone();
            if (menu_cat.name === 'CHOOSE FROM THE FOLLOWING:') {
              $cat_template.addClass('singleUseTemplate').addClass('option-hide');
            }
            const tabId = menu_cat.id;
            const panelId = 'panel-' + menu_cat.id;

            // setup the filter button 
            $cat_template.find('button.category-selection-button').attr({
              'id': tabId,
              // 'role': 'tab',
              // 'aria-controls': panelId,
              // 'aria-selected': 'false',
              // 'tabindex': '-1' 
            });
            $cat_template.find("button.category-selection-button [data-label-name]").text(menu_cat.name);

            //the Menu Category
            var $menu_category = $("[data-menu-category-template].hide").clone();
            $menu_category.attr({
              'id': panelId,
              // 'role': 'tabpanel',
              // 'aria-labelledby': tabId,
              'data-category-id': menu_cat.id,
              'hidden': 'true' // Panels should be hidden by default
            });

            // Dropdown Option
            var $cat_dropdown_template = $("[data-category-filter-dropdown-template].hide").clone();

            $cat_dropdown_template
              .attr({
                'value': 'panel-' + menu_cat.id,
                'role': 'option'
              })
              .text(menu_cat.name)
              .removeClass('hide');

            $("#category-dropdown").append($cat_dropdown_template);

            // console.log('menu_cat', menu_cat);
            // Category Images
            var menuCatImage = '',
              menuCatImageAlt = menu_cat.name;

            if (menu.imagepath && menu_cat.images) {
              if (menu.imagepath && menu_cat.images.find((image) => image.groupname === "mobile-app-large")) {
                menuCatImage = menu.imagepath + menu_cat.images.find((image) => image.groupname === "mobile-app-large").filename;
                // Set alt if description exists
                if (menu_cat.images.find((image) => image.groupname === "mobile-app-large").description) {
                  menuCatImageAlt = menu_cat.images.find((image) => image.groupname === "mobile-app-large").description;
                }
              }
            }

            if (menuCatImage.length == 0) {
              if (menu_cat.image_url) {
                menuCatImage = menu_cat.image_url;
              }
            }

            // No image associated -- Show Placeholder 
            if (menuCatImage.length == 0) {
              menuCatImage = "/wp-content/themes/wildfire/assets/images/blog-placeholder.jpg";
            }

            $cat_template.find("img").attr("src", menuCatImage);
            $cat_template.find("img").attr("alt", menuCatImageAlt);
            $cat_template.removeClass("hide");

            let $cat_template_removed_button_function = $cat_template.clone(true, true);
            $cat_template_removed_button_function
              .find('button')
              .attr({
                'tabindex': '-1',
                'aria-hidden': 'true'
              });

            $(".category-selector .category-selector-wrap").append($cat_template);
            $(".category-selector-filter .category-selector-wrap").append($cat_template_removed_button_function);
            // console.log('adgdsg');



            $menu_category.find("[data-category-title]").text(menu_cat.name);
            $menu_category
              .find("[data-category-desc]")
              .text(menu_cat.description);

            // Display Menu Category Filter

            $.each(menu_cat.products, function (index, menu_item) {
              // console.log('menu_item', menu_item.name, menu_item.tags);
              //read only menu filter     
              if (menu_item.name.toLowerCase().replace(/\s+/g, '-').replace(/'/g, '') === readOnlyMenuItemCarryOver) {
                // console.log('Matching product:', menu_item.name, menu_item.id, menu_cat.id);
                matchFound = true;  // Set flag to true if a match is found
                matchProductID = menu_item.id;
              }
              //end read only menu filter

              var $menu_category_item = $(
                "[data-menu-item-template].hide"
              ).clone();

              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-menu-selection-id", menu_item.id);
              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-menu-selection-chain-id", menu_item.chainproductid);
              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-menu-selection-cost", menu_item.cost);
              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-minimum-quantity", menu_item.minimumquantity);
              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-maximum-quantity", menu_item.maximumquantity);

              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-quantity-increment", menu_item.quantityincrement);

              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-availability-now", menu_item.availability.now);
              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr(
                  "data-availability-isdisabled",
                  menu_item.availability.isdisabled
                );

              // console.log('ahhh');

              // Disable if unavailable for current delivery method
              if (
                menu_item.unavailablehandoffmodes.includes(
                  localStorage.getItem("ecw_customer_schedule")
                )
              ) {
                $menu_category_item
                  .find("[data-menu-selection-id]")
                  .prop("disabled", true);
              }

              // Disable if not available now
              if (!menu_item.availability.now) {
                $menu_category_item
                  .find("[data-menu-selection-id]")
                  .prop("disabled", true);
              }

              // Disabled if 86ed
              if (menu_item.availability.isdisabled) {
                $menu_category_item
                  .find("[data-menu-selection-id]")
                  .prop("disabled", true);
              }

              var menuImage = "";
              var menuImageDetail = "";

              if (menu.imagepath && menu_item.imagefilename) {
                menuImage = menu.imagepath + menu_item.imagefilename;
                if (
                  menu.imagepath &&
                  menu_item.images.find(
                    (image) => image.groupname === "mobile-app-large"
                  )
                ) {
                  menuImageDetail =
                    menu.imagepath +
                    menu_item.images.find(
                      (image) => image.groupname === "mobile-app-large"
                    ).filename;

                } else {
                  menuImageDetail = menuImage;
                }
              }
              else {
                // No image associated -- Show Placeholder
                menuImage =
                  "/wp-content/themes/wildfire/assets/images/blog-placeholder.jpg";
                menuImageDetail = menuImage;
              }
              $menu_category_item.find("img").attr("src", menuImageDetail);

              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-menu-image-url", menuImageDetail);
              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-menu-category", menu_cat.name);
              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-menu-category-url", '#menu-category-' + menu_cat.id);

              $menu_category_item
                .find("img")
                .attr("alt", menu_item.name);

              $menu_category_item
                .find("[data-menu-item-title]")
                .text(menu_item.name);

              if ('menuitemlabels' in menu_item && menu_item.menuitemlabels.length > 0) {
                console.log(menu_item.menuitemlabels);
                $menu_category_item
                  .find("[data-menuitemlabels]")
                  .html('<img src="' + menu_item.menuitemlabels[0].images[0].url + '" alt="' + menu_item.menuitemlabels[0].images[0].description + '">');
              } else {
                $menu_category_item
                  .find("[data-menuitemlabels]")
                  .remove();
              }
              if (menu_item && menu_item.tags && menu_item.tags.length > 0) {
                var $tagContainer = $menu_category_item.find("[data-menuitemtag]").empty();

                menu_item.tags.forEach(function (tag, index) {
                  var tagName = typeof tag === 'object' ? tag.name : tag;
                  var tagDescription = typeof tag === 'object' ? tag.description : '';

                  // Create unique IDs for ADA/ARIA associations
                  var descId = 'tag-desc-' + (menu_item.id || Math.random().toString(36).substr(2, 9)) + '-' + index;

                  var $tagWrapper = $('<div class="menu-item-tag-wrapper"></div>');

                  var $tagBtn = $('<button type="button" class="menu-item-tag" aria-expanded="false"></button>')
                    .text(tagName);

                  if (tagDescription) {
                    $tagBtn.attr('aria-describedby', descId);
                    $tagBtn.attr('aria-label', tagName + ': ' + tagDescription);

                    var $desc = $('<span class="menu-item-tag-description" role="tooltip"></span>')
                      .attr('id', descId)
                      .text(tagDescription);

                    $tagWrapper.append($tagBtn).append($desc);
                  } else {
                    $tagWrapper.append($tagBtn);
                  }

                  $tagContainer.append($tagWrapper);
                });

                $menu_category_item.find("[data-menuitemtags]").removeClass('hide');
              } else {
                $menu_category_item.find("[data-menuitemtags]").addClass('hide');
                $menu_category_item.find("[data-menuitemtag]").empty();
              }
              $menu_category_item
                .find("[data-menu-item-calories]")
                .text(menu_item.basecalories);

              $menu_category_item
                .find("[data-menu-item-desc]")
                .text(menu_item.description);

              if (menu_item.cost !== 0) {
                $menu_category_item
                  .find("[data-menu-item-price]")
                  .text("$ " + formatMoney(menu_item.cost));
              } else {
                $menu_category_item
                  .find("[data-menu-item-price]")
                  .addClass("hide");
              }

              var calories = "";
              if (menu_item.basecalories !== null) {
                calories = menu_item.basecalories;
              }
              if (menu_item.maxcalories !== null) {
                if (calories.length) {
                  calories += " " + menu_item.caloriesseparator + " ";
                }
                calories += menu_item.maxcalories;
              }

              if (calories.length) {
                calories += " Cal";
              }

              $menu_category_item
                .find("[data-menu-item-calories]")
                .text(calories);

              $menu_category_item.removeClass("hide");
              $menu_category.append($menu_category_item);
            });

            if (menu_cat.products.length > 0) {
              $menu_category.find("[data-menu-item-template].hide").remove();
              $menu_category.removeClass("hide");
              $(".wf-ordering-menu .menu-grid").append($menu_category);
            }
          }
          $.each(menu.categories, function (index, menu_cat) {
            createMenuCategories(index, menu_cat)
          }); // $.each(menu.categories
          $.each(menu.singleusecategories, function (index, menu_cat) {
            createMenuCategories(index, menu_cat);
            // $cat_template.addClass('option-hide');
          }); // $.each(menu.categories

          // Back Button Default
          // $defaultBackAction = true;
          // if ($('.reveal-overlay [data-back-button]').length > 0) {
          //   $defaultBackAction = false;
          // }
          $backBtn = $(".wf-ordering-container [data-back-button], #menu-select-order-type [data-back-button]");
          $backBtn.click(function () {
            // if ($defaultBackAction) {
            localStorage.removeItem('ecw_confirm_location');
            localStorage.removeItem('ecw_visitor_store_latitude');
            localStorage.removeItem('ecw_visitor_store_longitude');
            change_view('start-order');
            // }
          });
          $('[data-category-selector-template]:not(.hide) input[type="radio"], select#category-dropdown, [data-category-selector-all]:not(.hide) input[type="radio"]').change(function () {
            // console.log('$(this)', $(this));
            onCategoryChange($(this));

          });
          $(document).on('click keydown', '.category-selector-item:not(.hide) button.category-selection-button', function (e) {
            // Handle keyboard activation
            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
              return;
            }
            // Prevent space from scrolling the page
            if (e.key === ' ') {
              e.preventDefault();
            }
            onCategoryChange($(this));
          });





          // Open Menu Item
          $("button.menu-item-selector").click(function () {
            change_view('menu-product-' + $(this).data('menu-selection-id'), noHashChange = true);
            // console.log("orderingViewPDP")
            counter = 0;

            orderingViewPDP($(this), editBasketItem);
            $('html, body').animate({ scrollTop: 0 }, 'fast', function () {
              // console.log("I scrolled up");
            });
          }); // $('button.menu-item-selector').click
          //read only menu forwarding 
          if (!matchFound && readOnlyMenuItemCarryOver || !matchFound && readOnlyCategoryMenuItemCarryOver) {
            console.log('No match on any--display location disclaimer');

            $('#read-only-menu-disclaimer').removeClass('hide');
            $('#read-only-menu-disclaimer').attr('aria-hidden', 'false');
            if (readOnlyCategoryMenuItemCarryOver) {
              $('#read-only-menu-disclaimer img').attr('src', readOnlyCategoryMenuItemCarryOverImg);
              $('#read-only-menu-disclaimer img').attr('alt', readOnlyCategoryMenuItemCarryOver);
            } else {
              $('#read-only-menu-disclaimer img').attr('src', readOnlyMenuItemCarryOverImg);
              $('#read-only-menu-disclaimer img').attr('alt', readOnlyMenuItemCarryOver);
            }

            //close
            $(document).keydown(function (event) {
              if (event.key === "Escape") {
                $('#read-only-menu-disclaimer').addClass('hide');
              }
            });
            $(document).click(function (event) {
              // Check if the click target is outside of the .content div
              if (!$(event.target).closest('#read-only-menu-disclaimer .content').length) {
                $('#read-only-menu-disclaimer').addClass('hide');
              }
            });
            $('#viewMenu').click(function () {
              $('#read-only-menu-disclaimer').addClass('hide');
            });
            ecw_hide_overloading();


          } else if (readOnlyMenuItemCarryOver) {
            $('.wf-ordering-menu').addClass('hides');

            ecw_show_overloading();

            $('#read-only-menu-disclaimer').addClass('hide');
            $('#read-only-menu-disclaimer').attr('aria-hidden', 'true');
            let $button = $(`[data-menu-selection-id="${matchProductID}"]`);

            if ($button.length) {
              // $button.click();
              onCategoryChange($button);

              localStorage.removeItem('readOnlyMenuItemCarryOver');
              localStorage.removeItem('readOnlyMenuItemCarryOverImg');
              setTimeout(function () {
                ecw_hide_overloading();
              }, 500);
            } else {
              ecw_hide_overloading();

            }
          } else if (readOnlyCategoryMenuItemCarryOver) {
            ecw_show_overloading();

            $('#read-only-menu-disclaimer').addClass('hide');
            $('#read-only-menu-disclaimer').attr('aria-hidden', 'true');
            let $label = $(`button#${matchProductID}`);
            console.log('matchProductID', $label);

            if ($label.length) {
              onCategoryChange($label);
              localStorage.removeItem('readOnlyCategoryMenuItemCarryOver');
              localStorage.removeItem('readOnlyCategoryMenuItemCarryOverImg');
              setTimeout(function () {
                ecw_hide_overloading();
              }, 500);
            } else {
              console.log(':(')
              ecw_hide_overloading();

            }
          }
          //end of read only menu forwarding



          if (editBasketItem) {
            // open Product to edit
            $(
              "button.menu-item-selector[data-menu-selection-id=" +
              editBasketProduct +
              "]"
            ).click();
          }

          if (editBasketItem == 0 && editBasketProduct > 0) {
            $(
              "button.menu-item-selector[data-menu-selection-id=" +
              editBasketProduct +
              "]"
            ).click();
          }
        },
        complete: function () {
          ecw_hide_loading();
          $(".wf-ordering-menu").removeClass("hide");
        },
      });


      if (openCart && $('#cart-view').length) {
        // console.log('view cart');
        view_cart();

      } else {
        // console.log('not view cart!');

        not_view_cart();
      }

      getOrderTypeEditPopupInfo();
      setGoogleReferral();

      // console.log('done');
      $('.menu-category').addClass('done-loading');
    })
    .hide()
    .fadeIn(transitionDuration);

}
var counter = 0;
function setItemOptions(group) {


  var $ = jQuery;
  var fieldsetLegend = '<span class="legend-name">' + group.description + '</span>';
  // console.log('menu item', group);

  var $groupTemplate = $("[data-product-option-group].hide").clone();

  // Modifier ID (option id)
  $groupTemplate
    .find("[data-product-options]")
    .attr("data-chainmodifierid", group.chainmodifierid);
  // OLO: If the value is true, the user must select one and only one of the options in the group (e.g. true = radio buttons; false = checkboxes). Please reference this attribute before considering any of the other attributes listed below.
  $groupTemplate
    .find("[data-product-options]")
    .attr("data-mandatory", group.mandatory);
  // OLO: If the value is true, the user may select multiple quantities of any option they choose.
  $groupTemplate
    .find("[data-product-options]")
    .attr("data-supportschoicequantities", group.supportschoicequantities);
  // OLO: The minimum number of distinct options that the user must choose.
  $groupTemplate
    .find("[data-product-options]")
    .attr("data-minselects", group.minselects);
  $groupTemplate
    .find("[data-product-options]")
    .attr("data-minaggregateselects", group.minaggregatequantity);

  // OLO: The maximum number of distinct options that the user may choose.
  $groupTemplate
    .find("[data-product-options]")
    .attr("data-maxselects", group.maxselects);
  // OLO: The minimum quantity for each choice the user selects.
  $groupTemplate
    .find("[data-product-options]")
    .attr("data-minchoicequantity", group.minchoicequantity);

  // OLO: The maximum quantity for each choice the user selects.
  $groupTemplate
    .find("[data-product-options]")
    .attr("data-maxchoicequantity", group.maxchoicequantity);

  $groupTemplate
    .find("[data-product-options]")
    .attr("data-choicequantityincrement", group.choicequantityincrement);

  var selectMin = 0;
  var selectMax = 0;

  var isValid = true;
  var isRequired = false;

  if (group.explanationtext) {
    fieldsetLegend += '<span class="explanationtext">' + group.explanationtext + '</span>';
  }

  if (
    (group.mandatory ||
      (group.minselects && group.minselects > 0) ||
      (group.minchoicequantity !== "" && group.minchoicequantity > 0)) && (!fieldsetLegend.includes('Ingredients'))
  ) {
    isValid = false;
    isRequired = true;
  }

  $groupTemplate.find("[data-product-options]").attr("data-is-valid", isValid);
  if (isRequired) {
    // console.log('is required', fieldsetLegend);

    $groupTemplate
      .find("[data-product-options]")
      .attr("data-is-required", isRequired);

    $groupTemplate.find('.accordion-trigger').attr("data-is-required", isRequired).attr("data-is-valid", isValid);
    $groupTemplate.find('.accordion-trigger p').text(' Required menu modifers inside this accordian');
    // console.log($groupTemplate.find('.accordion-trigger p'))
  }

  if (group.minchoicequantity > selectMin) {
    selectMin = group.minchoicequantity;
  }
  if (group.maxchoicequantity > selectMax) {
    selectMax = group.maxchoicequantity;
  }

  if (group.minselects > selectMin) {
    selectMin = group.minselects;

  }


  if (group.maxselects > selectMax) {
    selectMax = group.maxselects;
  }
  if ((group.minaggregatequantity > group.minselects) && selectMin > 0 && selectMax > 0) {

    if (selectMax === group.minaggregatequantity) {
      fieldsetLegend +=
        "<span>Select an aggregate total of " + group.minaggregatequantity + ".</span>";
    } else {
      fieldsetLegend +=
        "<span>Select options ( minimum " + group.minaggregatequantity + ", maximum " + selectMax + ").</span>";
    }
  } else if (selectMin > 0 && selectMax > 0) {
    fieldsetLegend +=
      "<span>Select between " + selectMin + " and " + selectMax + "</span>";
  }

  if (isRequired) {
    fieldsetLegend += "<span data-mandatory-label></span>";
  }

  $groupTemplate
    .find("[data-product-options] legend[data-item-selector]")
    .html(fieldsetLegend);

  //accordain stuff
  counter++;
  // console.log('counter', counter, fieldsetLegend);
  $groupTemplate.find('.accordion-trigger span').text(counter + ': ' + group.description.replace(':', ''));
  $groupTemplate.find('.accordion-trigger').attr("aria-controls", group.id);
  $groupTemplate.find('.accordion-panel').attr("id", group.id);
  //

  //get meta data
  let selectHeatLevelsFormatting = false;
  let selectHeatIndexSelector = false;
  let selectFlavorSelector = false;
  if (group.metadata && Array.isArray(group.metadata)) {
    group.metadata.forEach(function (meta) {
      // console.log('Key:', meta.key, 'Value:', meta.value);
      if (meta.key === 'heatLevelsFormatting' && meta.value === 'TRUE') {
        selectHeatLevelsFormatting = true;
      }
      if (meta.key === 'heatIndexFormatting' && meta.value === 'TRUE') {
        selectHeatIndexSelector = true;
      }
      if (meta.key === 'heatFlavorFormatting' && meta.value === 'TRUE') {
        selectFlavorSelector = true;
      }
    });
  }

  // Set up options
  // Helper function to build and append the option field so we don't duplicate code
  function processOptionField(option, $appendToTarget, metaClass) {
    var $optionField = $groupTemplate
      .find("[data-product-option].hide")
      .clone();

    // Add the metaClass if it was passed in (when selectFlavorSelector is true)
    if (metaClass) {
      $optionField.addClass(metaClass);
    }

    $optionField.find("input[data-item-selector]").attr("id", option.id);
    $optionField
      .find("input[data-item-selector]")
      .attr("data-chainoptionid", option.chainoptionid);
    $optionField
      .find("input[data-item-selector]")
      .attr("data-available-now", option.availability.now);
    $optionField
      .find("input[data-item-selector]")
      .attr("name", "select-" + group.chainmodifierid);

    $optionField.find("input[data-item-selector]").attr("data-cost", option.cost);
    $optionField.find("input[data-item-selector]").attr("data-calories", option.basecalories);
    $optionField.find("label[data-item-selector]").attr("for", option.id);

    $optionField.find("[data-info]").attr("data-option-id", option.id);

    if (group.mandatory) {
      $optionField.find("input").attr("type", "radio");
    }

    if (group.supportschoicequantities) {
      $optionField
        .find("[data-qty-select] label")
        .html('Select between ' + group.minchoicequantity + ' and ' + group.maxchoicequantity).removeClass('sr-only');

      setQuantityElem(
        $optionField.find("[data-qty-select]"),
        group.minchoicequantity,
        group.maxchoicequantity,
        group.choicequantityincrement
      );
      $optionField
        .find("[data-qty-select] input")
        .attr("data-qty-for", option.id);
      $optionField
        .find("[data-qty-select] input")
        .attr("id", "item-qty-" + option.id);
      $optionField
        .find("[data-qty-select] label")
        .attr("for", "item-qty-" + option.id);

      $optionField
        .find("[data-qty-select]")
        .attr("data-qty-container-for", option.id);
      $optionField.find("[data-qty-select]").removeClass("hide");
      $optionField.find("[data-qty-select-simple]").remove();
    } else {
      $optionField.find("[data-qty-select]").remove();
      $optionField.find("[data-qty-select-simple]").remove();
    }

    // Build the label
    // Select default options
    if (option.isdefault === true) {
      $optionField.find("input").attr('radiodefualtcheckedstate', 'true');
      $optionField.find("input").parent().addClass('selected');
    }

    var labelText = "<span data-image></span><strong>" + option.name + "</strong>";
    var labelCalories = "";

    if (option.basecalories) {
      labelCalories = option.basecalories;
    }
    if (option.maxcalories) {
      if (option.caloriesseparator && labelCalories.length) {
        labelCalories += " " + option.caloriesseparator + " ";
      }
      labelCalories += option.maxcalories;
    }

    if (labelCalories.length) {
      labelCalories += " calories";
      if (option.cost) {
        labelText += "<span data-calories class='cal-left-margin'> | Adds " + labelCalories + "</span>";
      } else {
        labelText += "<span data-calories>Adds " + labelCalories + "</span>";
      }
    } else {
      labelText = "<span data-image></span><strong>" + option.name + "<span data-calories></span></strong>";
    }

    // Heat Index classes
    if (option.name.includes("Virgin")) {
      $optionField.addClass('virgin');
    } else if (option.name.includes("Mild")) {
      $optionField.addClass('mild');
    } else if (option.name.includes("Dry Rub")) {
      $optionField.addClass('dry-rub');
    } else if (option.name.includes("Medium")) {
      $optionField.addClass('medium');
    } else if (option.name.includes("Hot") && !option.name.includes("X-Hot")) {
      $optionField.addClass('hot');
    } else if (option.name.includes("X-Hot")) {
      $optionField.addClass('x-hot');
    } else if (option.name.includes("Volcanic")) {
      $optionField.addClass('volcanic');
    } else if (option.name.includes("Insanity")) {
      $optionField.addClass('insanity');
    }

    var labelCost = "";
    if (option.cost) {
      labelCost += '<span>$' + formatMoney(option.cost) + '</span>';
      labelText += labelCost;
    }

    $optionField.find("label[data-item-selector]").html(labelText);
    $optionField.removeClass("hide");

    // Append to the target passed into the function (either the wrapper or the default container)
    $appendToTarget.append($optionField);

    setItemModifiers(option, $groupTemplate, selectHeatIndexSelectorHappenedOnce = false);
  }



  if (selectFlavorSelector) {

    var groupedOptions = {};

    // 1. Group options by meta.value
    $.each(group.options, function (index, option) {
      if (option.metadata && Array.isArray(option.metadata) && option.metadata.length > 0) {
        option.metadata.forEach(function (meta) {
          if (!groupedOptions[meta.value]) {
            groupedOptions[meta.value] = [];
          }
          groupedOptions[meta.value].push(option);
        });
      } else {
        if (!groupedOptions["Uncategorized"]) {
          groupedOptions["Uncategorized"] = [];
        }
        groupedOptions["Uncategorized"].push(option);
      }
    });

    // 2. Loop over each group, build wrappers, and process options
    $.each(groupedOptions, function (metaValue, options) {
      // Sanitize the metaValue to create a class
      var metaClass = metaValue.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-_]/g, '');

      // Create a wrapper div for this group
      var $groupWrapper = $('<div></div>').addClass('modifier-group-wrapper ' + metaClass);
      var $groupHeader = $('<h3></h3>').text(metaValue).addClass('modifier-group-title');
      $groupWrapper.append($groupHeader);

      // Loop through options in this specific group
      options.forEach(function (option) {
        // Pass the $groupWrapper as the target so it appends inside the wrapper
        processOptionField(option, $groupWrapper, metaClass);
      });

      // Append the entire group wrapper to the main modifiers container
      $groupTemplate.find("[data-product-options]").append($groupWrapper);
    });
  } else {
    // If selectFlavorSelector is false, fallback to the original straight loop
    $.each(group.options, function (index, option) {
      // Pass the standard container as the target
      processOptionField(option, $groupTemplate.find("[data-product-options]"));
    });
  }

  if (selectHeatLevelsFormatting) {
    $groupTemplate.find('.accordion-trigger span').text(counter + ': SELECT HEAT LEVEL + FLAVOR');

    $groupTemplate.find('[data-product-options]').addClass('heat-indexes');
    $groupTemplate.find('[data-product-options] legend').after('<div class="button-wrapper"><button id="heat-indexes-popup" class="button transparent-button" aria-controls="heat-indexes-popup" aria-expanded="false"  class="">VIEW HEAT LEVELS</button></div>');
    // console.log('adsgasdg', fieldsetLegend);
  } else if (selectHeatIndexSelector) {

    //accordain stuff .text(modifier.description)
    let desc = group.description;
    let boldedDesc = desc;
    let triggers = ["Select heat index for", "Select heat level for"]; // both triggers

    triggers.forEach(function (trigger) {
      if (desc.includes(trigger)) {
        let parts = desc.split(trigger);
        boldedDesc = parts[0] + trigger + " <strong>" + parts[1].trim() + "</strong>";
      }
    });


    // var $dataModifierGroups = $groupTemplate.find("div.accordion-panel").attr("id", group.id);
    var $dataModifierGroups = $groupTemplate.find("[data-product-options]");
    // $dataModifierGroups.addClass('asdgasdg');
    // console.log($dataModifierGroups);

    $dataModifierGroups.before('<p fake-legend >Select Heat Level + Flavor:</p>');
    $dataModifierGroups.before('<button id="flavors-popup" class="button transparent-button" aria-controls="flavors-popup" aria-expanded="false" >Find your flavor</button>');

    $dataModifierGroups.before('<p fake-popup-above-label > ' + boldedDesc + '</p>');
    $dataModifierGroups.before('<button role="button" class="accordion-trigger-fake-dropdown" aria-expanded="false" aria-controls="' + group.id + '" id="product-options-trigger" ><strong>Choose your heat level</strong></button>');

    $dataModifierGroups.addClass('accordion-panel-fake-dropdown').addClass('accordion-panel').attr("id", group.id).attr("hidden", "hidden");
    $dataModifierGroups.find('span.product-option-container').append('<svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none"><path d="M14.9219 3.32133C14.9616 2.60975 14.7568 1.90834 14.3426 1.33713C13.9283 0.765915 13.3303 0.360411 12.6508 0.190009C12.4956 0.151304 12.3311 0.176968 12.1934 0.261355C12.0558 0.345743 11.9563 0.481941 11.9169 0.639988C11.8775 0.798035 11.9014 0.964984 11.9833 1.10411C12.0652 1.24323 12.1984 1.34314 12.3537 1.38184C12.7255 1.47455 13.0578 1.68503 13.3026 1.98296C13.5474 2.28089 13.6922 2.6509 13.7161 3.03967C12.5611 2.92702 11.4013 3.24061 10.4485 3.92316C9.49576 4.60571 8.81358 5.61166 8.52661 6.75726C7.65835 10.2396 5.19397 12.0977 1.20006 12.2887C0.927125 12.3008 0.665487 12.4064 0.457844 12.5884C0.2502 12.7704 0.108812 13.018 0.056753 13.2909C0.00469323 13.5637 0.045035 13.8456 0.171196 14.0906C0.297356 14.3356 0.501886 14.5292 0.75141 14.6399C1.80284 15.1076 2.89285 15.4818 4.00927 15.7583C6.99294 16.5022 10.4831 16.6485 13.2669 15.2609C15.606 14.0956 17.1618 12.0197 17.8917 9.09224C18.1823 7.92173 18.0403 6.68718 17.4928 5.62323C16.9452 4.55928 16.0303 3.74008 14.9219 3.32133Z" fill="#BAB9BA"></path></svg>');
  } else if (selectFlavorSelector) {
    var $dataModifierGroups = $groupTemplate.find("[data-product-options]");

    $dataModifierGroups.before('<button id="customizer-information-popup" data-chainmodifierid="' + group.id + '" aria-controls="customizer-popup-' + group.id + '" aria-expanded="false" data-is-valid="true" class="first-item">Choose your flavor</button>');
    $dataModifierGroups.before('<div popup-overlay class="hide-popup" data-chainmodifierid="' + group.id + '"> </div>');

    $dataModifierGroups.addClass('hide-popup').attr('data-fake-id', 'fake-popup').attr('role', 'dialog').attr('aria-hidden', 'false').attr('id', 'customizer-popup-' + group.id).attr('aria-labelledby', 'dialog-title-' + group.id).attr('aria-modal', 'true').attr('data-chainmodifierid', group.id);
    $dataModifierGroups.find('legend').attr('aria-labelledby', 'dialog-title-' + group.id).append('<button data-close-popup class="close-button"><span class="sr-only">Close popup</span><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M2 23L23.2132 1.7868" stroke="white" stroke-width="3"/><path d="M2 2L23.2132 23.2132" stroke="white" stroke-width="3"/></svg></button>');
    $dataModifierGroups.append('<div class="button-cont"><button data-close-popup class="button close-customizer-information-popup" tabindex="0">Update Order</button></div>');

    if (selectMin > 0 && selectMax > 0) {
      // console.log('asdgasdgdsg', option.name);
    } else {
      // console.log('sdfhsdf', option.name);
      $dataModifierGroups.find('legend').append('<span></span>');

    }
  }
  else if (fieldsetLegend.includes('Ranch or Bleu Cheese')) {
    $groupTemplate.find('.accordion-trigger span').text(counter + ': SELECT DIPPING SAUCE');
  } else if (fieldsetLegend.includes('Wing specials request')) {
    $groupTemplate.find('.accordion-trigger span').text(counter + ': Specials request');
  } else if (fieldsetLegend.includes('Uncheck to remove')) {
    $groupTemplate.find('.accordion-trigger span').text(counter + ': Customize');
  }

  $groupTemplate.removeClass("hide");
  $groupTemplate.find("input").attr("tabindex", "0");

  $("#product-detail-view .product-option-wrap").append($groupTemplate);
} // setItemOptions(options, $groupTemplate, group)

let selectIngredientsID = [];
function setItemModifiers(option, $groupTemplate, modifierLevel = 0, selectHeatIndexSelectorHappenedOnce = false) {
  //
  // console.log('i call')
  var $ = jQuery;
  // Set Modifiers
  $.each(option.modifiers, function (index, modifier) {
    let fieldsetLegend = '<span class="legend-name">' + modifier.description + '</span>';
    let modifierID = modifier.id;

    //get meta data
    let selectHeatIndexSelector = false;
    let selectFlavorSelector = false;

    if (modifier.metadata && Array.isArray(modifier.metadata)) {
      modifier.metadata.forEach(function (meta) {
        // console.log('Key:', meta.key, 'Value:', meta.value);
        if (meta.key === 'heatIndexFormatting' && meta.value === 'TRUE') {
          selectHeatIndexSelector = true;
        }
        if (meta.key === 'heatFlavorFormatting' && meta.value === 'TRUE') {
          selectFlavorSelector = true;
        }
      });
    }



    var $modifierGroup = $groupTemplate
      .find("[data-modifier-group].hide")
      .clone();

    // selection limiters
    if (modifier.minselects != null) {
      $modifierGroup.attr("data-minselects", modifier.minselects);
    }
    if (modifier.maxselects != null) {
      $modifierGroup.attr("data-maxselects", modifier.maxselects);
    }
    if (modifier.minchoicequantity != null && !modifier.minchoicequantity === "") {
      $modifierGroup.attr("data-minchoicequantity", modifier.minchoicequantity);
    }
    if (modifier.maxchoicequantity != null && !modifier.maxchoicequantity === "") {
      $modifierGroup.attr("data-maxchoicequantity", modifier.maxchoicequantity);
    }
    if (modifier.choicequantityincrement != null && !modifier.choicequantityincrement === "") {
      $modifierGroup.attr("data-choicequantityincrement", modifier.choicequantityincrement);
    }
    //
    var selectMin = 0;
    var selectMax = 0;
    if (modifier.minchoicequantity > selectMin) {
      selectMin = modifier.minchoicequantity;
    }
    if (modifier.maxchoicequantity > selectMax) {
      selectMax = modifier.maxchoicequantity;
    }
    if (modifier.minselects > selectMin) {
      selectMin = modifier.minselects;
    }
    if (modifier.maxselects > selectMax) {
      selectMax = modifier.maxselects;
    }
    if (selectMin > 0 && selectMax > 0) {
      fieldsetLegend +=
        "<span>Select between " + selectMin + " and " + selectMax + "</span>";
    }



    $modifierGroup.attr("data-modifier-for", option.id);
    $modifierGroup.attr("data-modifier-id", modifierID);


    var isValid = true;
    var isRequired = false;

    if (modifier.explanationtext) {
      fieldsetLegend += '<span class="explanationtext">' + modifier.explanationtext + '</span>';
    }

    if (
      (modifier.mandatory ||
        (modifier.minselects && modifier.minselects > 0) ||
        (modifier.minchoicequantity !== "" && modifier.minchoicequantity > 0)) && (!fieldsetLegend.includes('Ingredients'))
    ) {
      isValid = false;
      isRequired = true;
    }

    $modifierGroup.attr("data-is-valid", isValid);

    if (isRequired) {
      $modifierGroup.attr("data-is-required", isRequired);

    }

    if (isRequired) {
      fieldsetLegend += "<span data-mandatory-label class='secondary-mandatory-label'></span>";
    }

    $modifierGroup.find("legend").html(fieldsetLegend);

    function m_optionChanges(m_option, $m_optionField) {

      $m_optionField.addClass('all-other-modifier-children');

      $m_optionField.find("input").attr("id", m_option.id);
      $m_optionField
        .find("input")
        .attr("data-chainoptionid", m_option.chainoptionid);

      $m_optionField
        .find("input")
        .attr('data-modifier-level', modifierLevel);

      $m_optionField
        .find("input")
        .attr('data-option-for-modifier', modifierID);

      $m_optionField
        .find("input")
        .attr("data-available-now", m_option.availability.now);

      $m_optionField.find("input").attr("name", "select-" + modifierID);
      $m_optionField.find("input").attr("data-cost", m_option.cost);
      $m_optionField.find("input").attr("data-calories", m_option.maxcalories);

      $m_optionField.find("label").attr("for", m_option.id);
      if (
        (modifier.mandatory)
      ) {
        $m_optionField.find("input").attr("type", "radio");
      }

      if (m_option.isdefault === true) {
        // console.log('defualt', fieldsetLegend);
        $m_optionField.find("input").attr('radiodefualtcheckedstate', 'true');
      }

      var labelText = "<span data-image></span><strong>" + m_option.name + "</strong>";
      if (selectFlavorSelector) {
        let value = m_option.name;

        // Match the last occurrence of -, –, or —
        let lastDashIndex = value.search(/[-–—](?!.*[-–—])/);

        let firstPart = lastDashIndex !== -1
          ? value.slice(0, lastDashIndex).trim()
          : value.trim();

        var labelText = `<span data-image></span><strong>${firstPart}</strong>`;
      }
      // end of select defualt options

      var labelCost = "";
      if (m_option.cost) {
        labelCost += "+$" + formatMoney(m_option.cost);
        labelText += labelCost;
      }

      var labelCalories = "";
      if (m_option.maxcalories && (m_option.basecalories !== null && m_option.basecalories !== "")) {
        labelCalories = m_option.basecalories + '-' + m_option.maxcalories;
      } else if (m_option.maxcalories) {
        labelCalories = m_option.maxcalories;
        $m_optionField.find("input").attr("data-calories", labelCalories);
      } else if (m_option.basecalories !== null && m_option.basecalories !== "") {
        labelCalories = m_option.basecalories;
        $m_optionField.find("input").attr("data-calories", labelCalories);

      }

      if (labelCalories.length) {
        labelCalories += " Calories";
        if (m_option.cost) {
          labelText += "<span data-calories class='cal-left-margin'> | Adds " + labelCalories + "</span>";
        } else {
          labelText += "<span data-calories>Adds " + labelCalories + "</span>";
        }
      } else {
        // hide calories if there are none
        // labelText += '<span data-calories></span>';
      }
      // console.log('option.name',option.name);
      if (m_option.name.includes("Virgin")) {
        $m_optionField.addClass('virgin');
      }
      else if (m_option.name.includes("Mild")) {
        $m_optionField.addClass('mild');
      }
      else if (m_option.name.includes("Dry Rub")) {
        $m_optionField.addClass('dry-rub');
      }
      else if (m_option.name.includes("Medium")) {
        $m_optionField.addClass('medium');
      }
      else if (m_option.name.includes("Hot")) {
        $m_optionField.addClass('hot');
      }
      else if (m_option.name.includes("X-Hot")) {
        $m_optionField.addClass('x-hot');
      }
      else if (m_option.name.includes("X-Hot")) {
        $m_optionField.addClass('x-hot');
      }
      else if (m_option.name.includes("Volcanic")) {
        $m_optionField.addClass('volcanic');
      }
      else if (m_option.name.includes("Insanity")) {
        $m_optionField.addClass('insanity');
      }

      $m_optionField.find("label").html(labelText);

    }
    if (!selectFlavorSelector) {

      $.each(modifier.options, function (index, m_option) {

        var $m_optionField = $modifierGroup
          .find("[data-product-option-modifier-option].hide")
          .clone();

        m_optionChanges(m_option, $m_optionField);



        $m_optionField.removeClass("hide");
        $modifierGroup.append($m_optionField);

      }); // $.each(modifier.options ...
    } else {
      // Group options by meta.value
      groupedOptions = {};

      $.each(modifier.options, function (index, m_option) {
        if (m_option.metadata && Array.isArray(m_option.metadata) && m_option.metadata.length > 0) {
          m_option.metadata.forEach(function (meta) {
            if (!groupedOptions[meta.value]) {
              groupedOptions[meta.value] = [];
            }
            groupedOptions[meta.value].push(m_option);
          });
        } else {
          if (!groupedOptions["Uncategorized"]) {
            groupedOptions["Uncategorized"] = [];
          }
          groupedOptions["Uncategorized"].push(m_option);
        }
      });


      // Loop over each group
      $.each(groupedOptions, function (metaValue, options) {
        // Sanitize the metaValue to create a class
        var metaClass = metaValue.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-_]/g, '');

        // Create a wrapper div for this group
        var $groupWrapper = $('<div></div>').addClass('modifier-group-wrapper ' + metaClass);
        var $groupHeader = $('<h3></h3>').text(metaValue).addClass('modifier-group-title');
        $groupWrapper.append($groupHeader);

        options.forEach(function (m_option) {
          var $m_optionField = $modifierGroup
            .find("[data-product-option-modifier-option].hide")
            .clone();

          // Optionally also add the metaClass to the field itself
          $m_optionField.addClass(metaClass);

          // Apply your existing logic to this individual m_option
          m_optionChanges(m_option, $m_optionField);

          $m_optionField.removeClass("hide");
          // Append to the group wrapper instead of $modifierGroup
          $groupWrapper.append($m_optionField);
        });

        // Append the entire group wrapper to the $modifierGroup
        $modifierGroup.append($groupWrapper);
      });

      // console.log('groupedOptions', groupedOptions);
    }



    $modifierGroup.removeClass("hide");
    $modifierGroup.find("input").attr("tabindex", "0");


    if (selectHeatIndexSelector) {

      //accordain stuff .text(modifier.description)
      let desc = modifier.description;
      let boldedDesc = desc;
      let triggers = ["Select heat index for", "Select heat level for"]; // both triggers

      triggers.forEach(function (trigger) {
        if (desc.includes(trigger)) {
          let parts = desc.split(trigger);
          boldedDesc = parts[0] + trigger + " <strong>" + parts[1].trim() + "</strong>";
        }
      });


      var $dataModifierGroups = $groupTemplate.find("[data-modifier-groups]");

      if (!selectHeatIndexSelectorHappenedOnce) {
        // console.log('asdgadsg', fieldsetLegend);
        $dataModifierGroups.append('<p fake-legend class="option-hide" data-modifier-for="' + option.id + '">Select Heat Level + Flavor:</p>');
        $dataModifierGroups.append('<button id="flavors-popup" class="button transparent-button" aria-controls="flavors-popup" aria-expanded="false" data-modifier-for="' + option.id + '">Find your flavor</button>');

      }
      $dataModifierGroups.append('<p fake-popup-above-label class="option-hide" data-modifier-for="' + option.id + '"> ' + boldedDesc + '</p>');
      $dataModifierGroups.append('<button class="accordion-trigger-fake-dropdown option-hide" aria-expanded="false" aria-controls="' + modifierID + '" id="product-options-trigger" data-modifier-for="' + option.id + '"><strong>Choose your heat level</strong></button>');

      $modifierGroup.addClass('accordion-panel-fake-dropdown').addClass('accordion-panel').attr("id", modifierID).attr("hidden", "hidden");
      $modifierGroup.find('span.all-other-modifier-children').append('<svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none"><path d="M14.9219 3.32133C14.9616 2.60975 14.7568 1.90834 14.3426 1.33713C13.9283 0.765915 13.3303 0.360411 12.6508 0.190009C12.4956 0.151304 12.3311 0.176968 12.1934 0.261355C12.0558 0.345743 11.9563 0.481941 11.9169 0.639988C11.8775 0.798035 11.9014 0.964984 11.9833 1.10411C12.0652 1.24323 12.1984 1.34314 12.3537 1.38184C12.7255 1.47455 13.0578 1.68503 13.3026 1.98296C13.5474 2.28089 13.6922 2.6509 13.7161 3.03967C12.5611 2.92702 11.4013 3.24061 10.4485 3.92316C9.49576 4.60571 8.81358 5.61166 8.52661 6.75726C7.65835 10.2396 5.19397 12.0977 1.20006 12.2887C0.927125 12.3008 0.665487 12.4064 0.457844 12.5884C0.2502 12.7704 0.108812 13.018 0.056753 13.2909C0.00469323 13.5637 0.045035 13.8456 0.171196 14.0906C0.297356 14.3356 0.501886 14.5292 0.75141 14.6399C1.80284 15.1076 2.89285 15.4818 4.00927 15.7583C6.99294 16.5022 10.4831 16.6485 13.2669 15.2609C15.606 14.0956 17.1618 12.0197 17.8917 9.09224C18.1823 7.92173 18.0403 6.68718 17.4928 5.62323C16.9452 4.55928 16.0303 3.74008 14.9219 3.32133Z" fill="#BAB9BA"></path></svg>');


      selectHeatIndexSelectorHappenedOnce = true;

    } else if (selectFlavorSelector) {
      var $dataModifierGroups = $groupTemplate.find("[data-modifier-groups]");
      $dataModifierGroups.append('<button id="customizer-information-popup" data-modifier-for="' + option.id + '" aria-controls="customizer-popup-' + option.id + '" aria-expanded="false" data-is-valid="false">Choose your flavor</button>');

      $dataModifierGroups.append('<div popup-overlay class="hide-popup" data-modifier-for="' + option.id + '"> </div>');
      $modifierGroup.addClass('hide-popup').attr('data-fake-id', 'fake-popup').attr('role', 'dialog').attr('aria-hidden', 'false').attr('id', 'customizer-popup-' + option.id).attr('aria-labelledby', 'dialog-title-' + option.id).attr('aria-modal', 'true');
      $modifierGroup.find('legend').attr('aria-labelledby', 'dialog-title-' + option.id).append('<button data-close-popup class="close-button"><span class="sr-only">Close popup</span><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M2 23L23.2132 1.7868" stroke="white" stroke-width="3"/><path d="M2 2L23.2132 23.2132" stroke="white" stroke-width="3"/></svg></button>');
      $modifierGroup.append('<div class="button-cont"><button data-close-popup class="button close-customizer-information-popup" tabindex="0">Update Order</button></div>');
      // Emily come back here
      if (selectMin > 0 && selectMax > 0) {
        // console.log('asdgasdgdsg', option.name);
      } else {
        // console.log('sdfhsdf', option.name);
        $modifierGroup.find('legend').append('<span></span>');

      }
    }
    $groupTemplate.find("[data-modifier-groups]").append($modifierGroup);



    $.each(modifier.options, function (index, m_option) {
      // Recurse modifier modifiers (lord lord)
      if (m_option.modifiers) {
        setItemModifiers(m_option, $groupTemplate, false, true, modifierLevel + 1);
      }
    });


  }); // $.each(option.modifiers ...
} // setItemModifiers(m_group)

var $ = jQuery;

jQuery(document).ready(function ($) {
  $ = jQuery;
  // Global/delegated event handlers for Click & Keyboard accessibility
  $(document).off('click.tagToggle').on('click.tagToggle', '.menu-item-tag-wrapper', function (e) {
    e.stopPropagation();
    var $wrapper = $(this);
    var $btn = $wrapper.find('.menu-item-tag');
    var isExpanded = $btn.attr('aria-expanded') === 'true';

    // Close all other tag tooltips
    $('.menu-item-tag-wrapper').not($wrapper).removeClass('is-active')
      .find('.menu-item-tag').attr('aria-expanded', 'false');

    // Toggle current tag
    $wrapper.toggleClass('is-active', !isExpanded);
    $btn.attr('aria-expanded', !isExpanded);
  });

  // Close tooltips when clicking outside or pressing Escape
  $(document).off('click.tagClose keydown.tagClose').on('click.tagClose keydown.tagClose', function (e) {
    if (e.type === 'click' || (e.type === 'keydown' && e.key === 'Escape')) {
      $('.menu-item-tag-wrapper').removeClass('is-active')
        .find('.menu-item-tag').attr('aria-expanded', 'false');
    }
  });
  function close50FlavorPopup($trigger) {
    // console.log('closeFlavorPopup');
    $triggerButton = $(`button#flavors-popup`);
    $triggerButton.attr('aria-expanded', 'false');
    triggerPopupOverlay = $(`[flavor-popup-overlay]`);

    triggerPopup = $trigger.closest('.flavor-popup');
    triggerPopup.attr('aria-hidden', 'true').addClass('hide-popup');
    triggerPopupOverlay.addClass('hide-popup');

    $triggerButton.focus();
    // console.log('i click', triggerPopup);
    $('[data-sticky-container]').removeClass('overlayFixSelector');
    $('header').removeClass('overlayFixSelector');
    $('footer').removeClass('overlayFixSelector');
  }
  function closeHeatIndexPopup($trigger) {
    $triggerButton = $(`button#heat-indexes-popup`);
    $triggerButton.attr('aria-expanded', 'false');
    // console.log('$triggerButton', $triggerButton);
    triggerPopupOverlay = $(`[heat-level-popup-overlay]`);

    triggerPopup = $trigger.closest('.heat-level-popup');
    triggerPopup.attr('aria-hidden', 'true').addClass('hide-popup');
    triggerPopupOverlay.addClass('hide-popup');

    $triggerButton.focus();

    // console.log('i click', triggerPopup);
    $('[data-sticky-container]').removeClass('overlayFixSelector');
    $('header').removeClass('overlayFixSelector');
    $('footer').removeClass('overlayFixSelector');
  }
  function closeFlavorPopup($trigger) {
    triggerFieldset = $trigger.closest('fieldset');

    //remove popup selection if there is none 
    let hasSelection = false;

    triggerFieldset.find('input').each(function () {
      if ($(this).is(':checked')) {
        hasSelection = true;
        return false; // Stop looping
      }
    });
    if (!hasSelection) {
      console.log('no selection');

      let selectedFieldsetFor = triggerFieldset.attr('data-modifier-for');
      if (!selectedFieldsetFor) {
        selectedFieldsetFor = triggerFieldset.attr('data-chainmodifierid');
      }
      let popupButton = $(`button#customizer-information-popup[data-modifier-for="${selectedFieldsetFor}"], button#customizer-information-popup[data-chainmodifierid="${selectedFieldsetFor}"]`);
      popupButton.removeClass('selected').text('Choose your flavor');
    }
    //
    triggerAttr = triggerFieldset.attr('data-modifier-for');

    if (!triggerAttr) {
      triggerAttr = triggerFieldset.attr('data-chainmodifierid');
    }

    triggerButton = $(`button[data-modifier-for="${triggerAttr}"], button[data-chainmodifierid="${triggerAttr}"]`);
    triggerPopupOverlay = $(`[popup-overlay][data-modifier-for="${triggerAttr}"], [popup-overlay][data-chainmodifierid="${triggerAttr}"]`);

    triggerFieldset.addClass('hide-popup').attr('aria-hidden', 'true');
    triggerButton.attr('aria-expanded', 'false');
    triggerPopupOverlay.addClass('hide-popup');

    triggerButton.focus();

    $('[data-sticky-container]').removeClass('overlayFixSelector');
    $('header').removeClass('overlayFixSelector');
    $('footer').removeClass('overlayFixSelector');
  }
  $(document).on('click', function (event) {
    //popup
    const $trigger = $(event.target);
    // console.log('i clicksss');
    if ($trigger.is('.accordion > button#product-options-trigger')) {
      var expanded = $trigger.attr('aria-expanded') === 'true';
      let controlsId = $trigger.attr('aria-controls');
      let $panel = $('.accordion-panel#' + controlsId);

      // Close all other accordions first
      $('.accordion button#product-options-trigger').attr('aria-expanded', 'false');
      $('.accordion .accordion-panel').attr('hidden', true).removeAttr('tabindex');

      if (!expanded) {
        // Open the clicked one
        $trigger.attr('aria-expanded', 'true');
        $panel.removeAttr('hidden');

        // Scroll to accordion, offset by header height
        let offset = ($('header').outerHeight() || 0) + 25;
        $('html, body').animate({
          scrollTop: $trigger.offset().top - offset
        }, 400);
        $panel.removeAttr('hidden').attr('tabindex', '-1').focus();

      }
    } else if ($trigger.is('button#product-options-trigger')) {
      var expanded = $trigger.attr('aria-expanded') === 'true';
      $trigger.attr('aria-expanded', !expanded);
      // var panelId = $trigger.attr('aria-controls'); 
      let controlsId = $trigger.attr('aria-controls');
      let $panel = $('fieldset.accordion-panel#' + controlsId);

      if (!$panel.length) {
        $panel = $trigger.siblings('fieldset');

        // console.log('$trigger', $trigger, controlsId);
        // console.log('$panel', $panel);
      }
      if (expanded) {
        $panel.attr('hidden', true).removeAttr('tabindex');
      } else {
        $panel.removeAttr('hidden').attr('tabindex', '-1').focus();
        // console.log('not expanded') 
      }

    }
    //generic flavors popup
    else if ($trigger.is('button#flavors-popup')) {
      triggerPopup = $(`.flavor-popup`);
      triggerPopupOverlay = $(`[flavor-popup-overlay]`);

      $trigger.attr('aria-expanded', 'true');
      triggerPopup.removeClass('hide-popup').attr('aria-hidden', 'false');
      triggerPopupOverlay.removeClass('hide-popup');
      triggerPopup.find('button[data-close-flavor-popup]').focus();

      $('header').addClass('overlayFixSelector');
      $('footer').addClass('overlayFixSelector');
      $('[data-sticky-container]').addClass('overlayFixSelector');

    } else if ($trigger.is('button[data-close-flavor-popup]')) {
      close50FlavorPopup($trigger);

    }
    //generic heat index popup
    else if ($trigger.is('button#heat-indexes-popup')) {
      triggerPopup = $(`.heat-level-popup`);
      triggerPopupOverlay = $(`[heat-level-popup-overlay]`);

      $trigger.attr('aria-expanded', 'true');
      triggerPopup.removeClass('hide-popup').attr('aria-hidden', 'false');
      triggerPopup.find('[data-close-heat-level-popup]').focus();

      triggerPopupOverlay.removeClass('hide-popup');

      $('header').addClass('overlayFixSelector');
      $('footer').addClass('overlayFixSelector');
      $('[data-sticky-container]').addClass('overlayFixSelector');

      const swiperEl = document.querySelector(
        '.wp-block-cb-carousel-v2.heat-index .swiper'
      );

      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.update();
      }


    } else if ($trigger.is('button[data-close-heat-level-popup]')) {
      closeHeatIndexPopup($trigger);
    }
    //all flavors popup
    else if ($trigger.is('button#customizer-information-popup')) {
      console.log('click on button#customizer-information-popup');

      let triggerAttr = $trigger.attr('data-modifier-for');

      // Fall back to data-chainmodifierid if data-modifier-for doesn't exist
      if (!triggerAttr) {
        triggerAttr = $trigger.attr('data-chainmodifierid');
      }

      triggerPopup = $(`fieldset[data-modifier-for="${triggerAttr}"], fieldset[data-chainmodifierid="${triggerAttr}"]`);
      triggerPopupOverlay = $(`[popup-overlay][data-modifier-for="${triggerAttr}"], [popup-overlay][data-chainmodifierid="${triggerAttr}"]`);

      console.log('triggerAttr', triggerAttr);
      console.log('triggerPopup', triggerPopup);

      $trigger.attr('aria-expanded', 'true');
      triggerPopup.removeClass('hide-popup').attr('aria-hidden', 'false');

      triggerPopup.find('button[data-close-popup].close-button').focus();

      triggerPopupOverlay.removeClass('hide-popup');

      $('header').addClass('overlayFixSelector');
      $('footer').addClass('overlayFixSelector');
      $('[data-sticky-container]').addClass('overlayFixSelector');

    } else if ($trigger.is('button[data-close-popup]')) {
      closeFlavorPopup($trigger);
    }
  });

  $(document).on('keydown', function (e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      // console.log('i escape');
      if ($('.flavor-popup').length && $('.flavor-popup').attr('aria-hidden') === 'false') {
        close50FlavorPopup($('.flavor-popup .inner-cont'));
      }
      if ($('.heat-level-popup').length && $('.heat-level-popup').attr('aria-hidden') === 'false') {
        closeHeatIndexPopup($('.heat-level-popup .inner-cont'));
      }
      if ($('fieldset[data-fake-id]').length && $('fieldset[data-fake-id]').attr('aria-hidden') === 'false') {
        closeFlavorPopup($('fieldset[data-fake-id][aria-hidden="false"]'));
      }
    }

    // Trap Focus Logic
    if (e.key === "Tab" || e.keyCode === 9) {
      let $activePopup = null;

      // Determine which popup is currently open
      if ($('.flavor-popup').length && $('.flavor-popup').attr('aria-hidden') === 'false') {
        $activePopup = $('.flavor-popup');
      } else if ($('.heat-level-popup').length && $('.heat-level-popup').attr('aria-hidden') === 'false') {
        $activePopup = $('.heat-level-popup');
      } else if ($('fieldset[data-fake-id]').length && $('fieldset[data-fake-id]').attr('aria-hidden') === 'false') {
        $activePopup = $('fieldset[data-fake-id][aria-hidden="false"]');
      } else if ($('fieldset[data-modifier-for][aria-hidden="false"]:not(.hide-popup)').length) {
        $activePopup = $('fieldset[data-modifier-for][aria-hidden="false"]:not(.hide-popup)');
      }

      if ($activePopup && $activePopup.length) {
        // Find all focusable elements inside the active popup
        const focusableSelectors = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
        const focusableElements = $activePopup.find(focusableSelectors).filter(':visible');

        if (focusableElements.length) {
          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];

          // If focus somehow left the popup, pull it back to the first element
          if (!$.contains($activePopup[0], document.activeElement) && document.activeElement !== $activePopup[0]) {
            e.preventDefault();
            firstElement.focus();
          }
          // Shift + Tab backward cycling
          else if (e.shiftKey) {
            if (document.activeElement === firstElement) {
              e.preventDefault();
              lastElement.focus();
            }
          }
          // Standard Tab forward cycling
          else {
            if (document.activeElement === lastElement) {
              e.preventDefault();
              firstElement.focus();
            }
          }
        }
      }
    }
  });
});